import Api from 'services/Api'
import { store } from 'store/reducers'
import { t } from 'translations'
import { Format } from 'services/Dates'
import { hasAccessToThis } from 'services/Utilities'
import { getCSV } from 'services/Utilities'

const exportCsvFormatted = async (filter: { rangeStart: string }): Promise<void> => {
  const {
    settings: { enableOccupations }
  } = store.getState() as MStore.RootState

  const { result: events } = await Api.post('reports', { type: 'dailyReport', date: Format(filter.rangeStart, { outFormat: 'date' }), ...filter })

  const fields = [
    { value: 'priority', label: t('manager.schedule.reports.PRIORITY') },
    { value: 'employeeNumber', label: t('manager.schedule.reports.EMPLOYEE_NUMBER') },
    { value: 'firstName', label: t('manager.schedule.reports.FIRSTNAME') },
    { value: 'lastName', label: t('manager.schedule.reports.LASTNAME') },
    { value: 'positionName', label: t('manager.schedule.reports.POSITION') },
    { value: 'startTime', label: t('manager.schedule.reports.START') },
    { value: 'endTime', label: t('manager.schedule.reports.END') },
    { value: 'status', label: t('manager.schedule.reports.STATUS') },
    { value: 'hoursWorkedThisPeriod', label: t('manager.schedule.reports.HOURS_WORKED') },
    { value: 'hoursPlannedThisPeriod', label: t('manager.schedule.reports.HOURS_PLANNED') },
    { value: 'locationTags', label: t('manager.schedule.reports.LOCATION_TAGS') },
    { value: 'regionalTags', label: t('manager.schedule.reports.REGION') },
    { value: 'clientTags', label: t('manager.schedule.reports.CLIENT_TAGS') },
    { value: 'resourceTags', label: t('manager.schedule.reports.RESOURCE_TAGS') },
    { value: 'isIrreplaceable', label: t('manager.schedule.reports.IRREPLACEABLE') },
    { value: 'needsReplacement', label: t('manager.schedule.reports.NEEDSREPLACEMENT') },
    { value: 'isExtraShift', label: t('manager.schedule.reports.VARIABLE_END_TIME') },
    { value: 'isOvertime', label: t('manager.schedule.reports.OVERTIME') },
    { value: 'isOnCall', label: t('manager.schedule.reports.ISONCALL') },
    { value: 'noEmployeeAvailable', label: t('manager.schedule.reports.NO_EMPLOYEE_AVAILABLE') },
    { value: 'hasSpecificRequirements', label: t('manager.schedule.reports.HAS_SPECIFIC_REQUIREMENTS') },
    { value: 'coveredOtherUnit', label: t('manager.schedule.reports.COVEREDOTHERUNIT') },
    { value: 'shiftComment', label: t('manager.schedule.reports.COMMENT') }
  ]

  if (hasAccessToThis('hiringDataSee')) {
    fields.splice(1, 0, { value: 'hiringDate', label: t('manager.schedule.reports.HIRING_DATE') })
  }
  if (enableOccupations) {
    fields.splice(5, 0, { value: 'primaryOccupation', label: t('manager.schedule.reports.PRIMARY_OCCUPATION') })
  }

  // Add the relevant fields when there is a project
  if (hasAccessToThis('projectSee')) {
    fields.push(
      { value: 'projectName', label: t('manager.schedule.reports.PROJECT') },
      { value: 'projectCode', label: t('manager.schedule.reports.PROJECT_CODE') },
      { value: 'projectOwners', label: t('manager.schedule.reports.PROJECT_OWNERS') },
      { value: 'lockedToProject', label: t('manager.schedule.reports.LOCKED_TO') },
      { value: 'preferredOnProject', label: t('manager.schedule.reports.PREFERRED_ON') },
      { value: 'blockedFromProject', label: t('manager.schedule.reports.BLOCKED_FROM') }
    )
  }

  // Replace missing data and format hiring date
  for (const event of events) {
    event.firstName = event.firstName !== '' ? event.firstName : 'N/A'
    event.lastName = event.lastName !== '' ? event.lastName : 'N/A'
    event.projectName = event.projectName !== '' ? event.projectName : 'N/A'
    if (hasAccessToThis('hiringDataSee') && event.hiringDate !== '' && event.hiringDate) event.hiringDate = Format(event.hiringDate, { outFormat: 'date' })
  }

  getCSV(events, fields, t('manager.schedule.reports.CSV_FORMATTED_REPORT_TITLE', { date: Format(filter.rangeStart, { outFormat: 'date' }) }))
}

export default exportCsvFormatted
